export default {
  Panel: {
    bg: "#fff",
    border: "1px solid",
    borderRadius: "md",
    borderColor: "gray.300",
  },
};
